import * as yup from 'yup';

export const addAgentValidation = yup.object({
  name: yup.string().required('*required'),
  module: yup.string().required('*required'),
  lga: yup.string().required('*required'),
  state: yup.string().required('*required'),
  phone: yup
    .string()
    .required('*required')
    .test(
      'Valid phone number',
      'number must start with +234 and must be valided nigerian number',
      (value) => /^\+234[0-9]{10}$/.test(value ?? '')
    ),
  email: yup.string().email('enter a valid email address').required('*required')
});
